module.exports = __webpack_public_path__ + "static/media/21-herlig.c2ee6427.mp3";